// extracted by mini-css-extract-plugin
export var attachment = "_qq-a";
export var emailContainer = "_qq-4";
export var emailContentPaddedContainer = "_qq-b";
export var emailHeader = "_qq-6";
export var emailIframe = "_qq-3";
export var emailInfoIcon = "_qq-9";
export var emailShortenedSummary = "_qq-e";
export var infoDropdown = "_qq-0";
export var infoRowBoundedContent = "_qq-d";
export var internal = "_qq-5";
export var merchant = "_qq-8";
export var messageInputContainer = "_qq-h";
export var normal = "_qq-7";
export var replyCard = "_qq-f";
export var subtleButton = "_qq-1";
export var subtleButtonIconContainer = "_qq-2";
export var toggleViewRepliesButton = "_qq-c";
export var wrappingText = "_qq-g";